import {
   differenceInMinutes,
   differenceInHours,
   differenceInDays,
   differenceInMonths,
   differenceInYears,
   differenceInSeconds
} from 'date-fns'

import {
   i18nType,
   scrollElementIntoView
} from '@flowwai-frontend/shared-web/common/ui'

export const scrollMessageIntoView = (
   messageId: string,
   options?: ScrollIntoViewOptions
): void => {
   setTimeout(() => {
      scrollElementIntoView(messageId, options)
   }, 300)
}

const getTimeText = (suffix: string, time: number) =>
   time <= 1 ? `1 ${suffix}` : `${time} ${suffix}s`

export const timeAgo = (pastDate: Date, t: i18nType) => {
   const now = new Date()
   const past = new Date(pastDate)

   const seconds = differenceInSeconds(now, past)
   const minutes = differenceInMinutes(now, past)
   const hours = differenceInHours(now, past)
   const days = differenceInDays(now, past)
   const months = differenceInMonths(now, past)
   const years = differenceInYears(now, past)

   switch (true) {
      case seconds < 60: {
         return getTimeText(t('second'), seconds)
      }
      case minutes < 60: {
         return getTimeText(t('min'), minutes)
      }
      case hours < 24: {
         return getTimeText(t('hour'), hours)
      }
      case days < 30: {
         return getTimeText(t('day'), days)
      }
      case months < 12: {
         return getTimeText(t('month'), months)
      }
      default: {
         return getTimeText(t('year'), years)
      }
   }
}
